import { EtiketlistesiPage } from './../etiketlistesi/etiketlistesi';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { Blletiket } from './../../../providers/bll/bll-etiket';
import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';

import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


/**
 * Generated class for the EtiketbasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-etiketbas',
  templateUrl: 'etiketbas.html',
})
export class EtiketbasPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  UrunListesi = [];
  etiketListesi:any = { ETIKET_DETAYLARI: [] };
  aktarilanliste=[];


  constructor(public navCtrl: NavController, public navParams: NavParams, public bllOrtak: BllOrtak,
  public toast:ToastController,
  public modalCtrl:ModalController,
  public ortak:Ortak,
    public barcodeScanner: BarcodeScannerProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EtiketbasPage');
    this.UrunAra();
  }
  UrunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.UrunListesi = sonuc.SonucObject;


    })
   

   
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }

  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      //console.log("barkod okutma sonucu",sonuc);
      this.aranan = sonuc.text;
     this.UrunAra();

    })
  }
  barkodara() {
    this.barcodeScanner.barkodOku().then(barcodeData => {
      console.log('Barcode data', barcodeData);
    }).catch(err => {
      console.log('Error', err);
    });
  }

  urunItemClick(urun) {

    console.log('gidenurun', urun)

    var blletiket = new Blletiket();
   blletiket.rafetiketkle(urun.StokKartiID, urun.ID,urun.StokAdi )
   this.presentToast(urun.StokAdi +"     "+"   "+"Listeye Eklendi");

      //this.etiketDetayListesi_Temp();


   

  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      // closeButtonText: "Tamam",
      position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  ozet() {
      let modal = this.modalCtrl.create(EtiketlistesiPage);
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
  
      modal.present();
  
    }
    help()
    {
      this.ortak.showBasicAlert("Nasıl Kullanılır","Listeden barkod okutarak veya manuel arama ile ilgili ürünler seçilir ve etiket simgesi ne dokunularak bir sonraki sayfaya gidilir oradan da gerekli düzenleme yapıldıktan sonra onayla tuşuna basılır");
    }
    
 
  
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/etiketbas/etiketbas.ts